export default __webpack_public_path__ + "sounds/chat-message.mp3";